import { render, staticRenderFns } from "./sale-view-info.vue?vue&type=template&id=740ff81c&"
import script from "./sale-view-info.ts?vue&type=script&lang=ts&"
export * from "./sale-view-info.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports